import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


const fetch_data = async (parms) => {

    const { fps_id, month, year } = parms;

    const response = await fetch(`${process.env.REACT_APP_URL_FPS}/fps/StatusDetails`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(parms),
    });

    let url = `${process.env.REACT_APP_URL_FPS}/Common/getFpsStatus?fpsId=${fps_id}`;

    if (month != null) {
        url += `&month=${month}`;
    }

    if (year != null) {
        url += `&year=${year}`;
    }

    const responseFpsStatus = await fetch(url, {
        method: "POST"
    });

    if (!response.ok || !responseFpsStatus.ok) {
        throw new Error('Failed to fetch data');
    }

    const data = await response.json();
    const fpsStatus = await responseFpsStatus.json();

    return {
        ...data,
        fpsStatus
    };
};


const FPS_Status_details = ({ fps_id, heading }) => {
    const [fpsStatus, setfpsStatus] = useState([]);
    const [fpsStatuslist, setFpsStatuslist] = useState([]);
    const [allotmentlist, setAllotmentlist] = useState([]);
    const [fpsstockdetails, setFpsstockdetails] = useState([]);
    const [registerlist, setRegisterlist] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div
    const tableRef = useRef(null);

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await fetch_data({ fps_id });

                if (response_data) {
                    setfpsStatus(response_data.fpsStatus);
                    setFpsStatuslist(response_data.fpsStatuslist);
                    setAllotmentlist(response_data.allotmentlist);
                    setFpsstockdetails(response_data.fpsstockdetails);
                    setRegisterlist(response_data.registerlist);

                } else {
                    setfpsStatus([]);
                    setFpsStatuslist([]);
                    setAllotmentlist([]);
                    setFpsstockdetails([]);
                    setRegisterlist([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [fps_id]);


    const handleDownload = async () => {

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("FPS Details");

        // ===== Title Row =====
        worksheet.mergeCells("A1:G1");

        const titleCell = worksheet.getCell("A1");
        titleCell.value = `FPS Details for ${fps_id} (FPS Name : ${fpsStatuslist[0].fps_NAME_EN}) (FpsStatus : ${fpsStatus[0].fps_status})`;

        titleCell.font = {
            bold: true,
            size: 14
        };

        titleCell.alignment = {
            horizontal: "center",
            vertical: "middle"
        };

        // ===== Header Row =====
        const headerRow = worksheet.addRow([
            "District",
            "Office",
            "Issue Point",
            "Device Id",
            "Dealer",
            "Nominee 1",
            "Nominee 2"
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true };

            cell.alignment = {
                horizontal: "center",
                vertical: "middle"
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "D9D9D9" } // light grey
            };

            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
        });

        // ===== Data Rows =====
        fpsStatuslist.forEach((item) => {
            const row = worksheet.addRow([
                item.dist_NAME_EN,
                `${item.afso_NAME_EN} (${item.afso_CODE})`,
                `${item.depot_NAME} (${item.depot_ID})`,
                item.device_ID,
                item.ownername,
                item.nom_1_NAME,
                item.nom_2_NAME
            ]);

            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            });
        });

        // ===== Column Width =====
        worksheet.columns = [
            { width: 20 },
            { width: 25 },
            { width: 35 },
            { width: 18 },
            { width: 25 },
            { width: 20 },
            { width: 20 }
        ];

        // ===== Generate File =====
        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "FPS_Details.xlsx");
    };

    const exportToExcelKeyRegister = async () => {

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Key Register Details");

        // Title Row
        worksheet.mergeCells("A1:F1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = `Key Register Details for ${fps_id}`;
        titleCell.font = { bold: true, size: 14 };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };

        // Header Row
        worksheet.addRow([
            "Sl.No",
            "Month",
            "Year",
            "Total Card",
            "Total Units",
            "Availed Cards"
        ]);

        const headerRow = worksheet.getRow(2);
        headerRow.font = { bold: true };
        headerRow.alignment = { horizontal: "center" };

        // Add Data
        registerlist.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                MonthC[item.month - 1],
                item.year || 0,
                item.total_cards || 0,
                item.total_units || 0,
                item.availed_cards || 0
            ]);
        });

        // Column Width
        worksheet.columns = [
            { width: 8 },
            { width: 15 },
            { width: 10 },
            { width: 15 },
            { width: 15 },
            { width: 15 }
        ];

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer]),
            `Key_Register_Details_${fps_id}.xlsx`
        );
    };

    const exportToExcelAllotment = async () => {

        if (!allotmentlist || allotmentlist.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Allotment Details");

        const commodityList = allotmentlist[0].lst;
        const commodityCount = commodityList.length;

        const totalColumns = 3 + commodityCount * 2;

        // ===== TITLE =====
        worksheet.mergeCells(1, 1, 1, totalColumns);

        const title = worksheet.getCell(1, 1);
        title.value = `Allotment Details for ${fps_id}`;
        title.font = { bold: true, size: 14 };
        title.alignment = { horizontal: "center", vertical: "middle" };

        // ===== HEADER ROW 1 =====
        worksheet.getCell(2, 1).value = "Sl.No";
        worksheet.getCell(2, 2).value = "Month";
        worksheet.getCell(2, 3).value = "Year";

        worksheet.mergeCells(2, 1, 3, 1);
        worksheet.mergeCells(2, 2, 3, 2);
        worksheet.mergeCells(2, 3, 3, 3);

        worksheet.getCell(2, 4).value = "Allotment (Kgs/Lts/Pkts)";
        worksheet.mergeCells(2, 4, 2, 3 + commodityCount);

        worksheet.getCell(2, 4 + commodityCount).value = "Sale (Kgs/Lts/Pkts)";
        worksheet.mergeCells(2, 4 + commodityCount, 2, 3 + commodityCount * 2);

        // ===== HEADER ROW 2 (Commodity Names) =====
        let col = 4;

        commodityList.forEach(c => {
            worksheet.getCell(3, col).value = c.comm_name_en;
            col++;
        });

        commodityList.forEach(c => {
            worksheet.getCell(3, col).value = c.comm_name_en;
            col++;
        });

        // ===== HEADER STYLE =====
        for (let r = 2; r <= 3; r++) {
            for (let c = 1; c <= totalColumns; c++) {

                const cell = worksheet.getCell(r, c);

                cell.font = { bold: true };

                cell.alignment = {
                    horizontal: "center",
                    vertical: "middle"
                };

                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "D9D9D9" }
                };

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            }
        }

        // ===== DATA =====
        let rowIndex = 4;

        allotmentlist.forEach((item, index) => {

            const row = worksheet.getRow(rowIndex);

            row.getCell(1).value = index + 1;
            row.getCell(2).value = MonthC[item.month - 1];
            row.getCell(3).value = item.year;

            let colIndex = 4;

            item.lst.forEach(c => {
                row.getCell(colIndex).value = c.allot_qty ?? 0;
                colIndex++;
            });

            item.lst.forEach(c => {
                row.getCell(colIndex).value = c.sale_qty ?? 0;
                colIndex++;
            });

            row.eachCell(cell => {

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };

                cell.alignment = {
                    horizontal: "right",
                    vertical: "middle"
                };

            });

            rowIndex++;
        });

        // ===== COLUMN WIDTH =====
        const cols = [
            { width: 10 },
            { width: 15 },
            { width: 10 }
        ];

        for (let i = 0; i < commodityCount * 2; i++) {
            cols.push({ width: 20 });
        }

        worksheet.columns = cols;

        // ===== DOWNLOAD =====
        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "Allotment_Details.xlsx");

    };

    const exportToExcelFpsDetalis = async () => {

        if (!fpsstockdetails || fpsstockdetails.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("FPS Stock Details");

        const totalColumns = 8;

        // ===== TITLE =====
        worksheet.mergeCells(1, 1, 1, totalColumns);

        const titleCell = worksheet.getCell(1, 1);
        titleCell.value = `FPS Stock Details for ${fps_id}`;
        titleCell.font = { bold: true, size: 14 };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };

        // ===== HEADER ROW 1 =====
        worksheet.getCell("A2").value = "Sl.No";
        worksheet.getCell("B2").value = "Commodity";
        worksheet.getCell("C2").value = "Alloted Qty";
        worksheet.getCell("D2").value = "OB Qty";
        worksheet.getCell("E2").value = "Received Qty";
        worksheet.getCell("G2").value = "Issued Qty";
        worksheet.getCell("H2").value = "CB Qty";

        // ===== MERGE CELLS =====
        worksheet.mergeCells("A2:A3");
        worksheet.mergeCells("B2:B3");
        worksheet.mergeCells("C2:C3");
        worksheet.mergeCells("D2:D3");
        worksheet.mergeCells("E2:F2");
        worksheet.mergeCells("G2:G3");
        worksheet.mergeCells("H2:H3");

        // ===== HEADER ROW 2 =====
        worksheet.getCell("E3").value = "Regular";
        worksheet.getCell("F3").value = "Extra";

        // ===== HEADER STYLE =====
        for (let r = 2; r <= 3; r++) {
            for (let c = 1; c <= totalColumns; c++) {

                const cell = worksheet.getCell(r, c);

                cell.font = { bold: true };

                cell.alignment = {
                    horizontal: "center",
                    vertical: "middle"
                };

                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "D9D9D9" }
                };

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            }
        }

        // ===== DATA ROWS =====
        let rowIndex = 4;

        fpsstockdetails.forEach((item, index) => {

            const row = worksheet.getRow(rowIndex);

            row.getCell(1).value = index + 1;
            row.getCell(2).value = item.comm_name_en;
            row.getCell(3).value = item.allotted_qty ?? 0;
            row.getCell(4).value = item.ob ?? 0;
            row.getCell(5).value = item.received_qty ?? 0;
            row.getCell(6).value = item.extra_ro ?? 0;
            row.getCell(7).value = item.issued_qty ?? 0;
            row.getCell(8).value = item.cb ?? 0;

            row.eachCell((cell) => {

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };

                cell.alignment = {
                    horizontal: typeof cell.value === "number" ? "right" : "left",
                    vertical: "middle"
                };
            });

            rowIndex++;

        });

        // ===== COLUMN WIDTH =====
        worksheet.columns = [
            { width: 10 },
            { width: 20 },
            { width: 15 },
            { width: 15 },
            { width: 15 },
            { width: 15 },
            { width: 15 },
            { width: 15 }
        ];

        // Freeze header rows
        worksheet.views = [{ state: "frozen", ySplit: 3 }];

        // ===== DOWNLOAD FILE =====
        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "FPS_Stock_Details.xlsx");
    };

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}><br /><br /><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }

    let keyregister_comp;
    let fpsstockdetails_comp;
    let allotment_comp;
    let fpsStatus_comp;

    if (fpsStatuslist == null && allotmentlist == null && fpsstockdetails == null && registerlist == null) {
        return <div class="mainhead" align="center">Details Not Found for Given FPS ({fps_id}) </div>;
    }

    if (fpsStatuslist == null || fpsStatuslist.length == 0) {
        fpsStatus_comp = <>
            <div class="mainhead" align="center">Details Not Found for Given FPS ({fps_id}) </div>            <br /><br />
        </>
    } else {
        fpsStatus_comp = <>

            <table ref={tableRef} align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'FPS Details  for '}
                            <font style={{ color: '#ff8000' }}> {fps_id} </font>
                            {'(FPS Name :'}
                            <font style={{ color: '#ff8000' }}> {fpsStatuslist[0].fps_NAME_EN} </font>
                            {')'}
                            {' (FpsStatus :'}
                            <font style={{ color: '#ff8000' }}> {fpsStatus[0].fps_status} </font>
                            {')'}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <td>District</td>
                        <td>office</td>
                        <td>Issue Point</td>
                        <td>Device Id</td>
                        <td>Dealer</td>
                        <td>Nominee 1</td>
                        <td>Nominee 2</td>
                    </tr>

                </thead>
                <tbody>
                    {
                        fpsStatuslist.map((item, index) => (
                            <tr key={item.dist_NAME_EN}>
                                <td style={{ textAlign: 'left' }}>{item.dist_NAME_EN}</td>
                                <td style={{ textAlign: 'left' }}>{item.afso_NAME_EN + '(' + item.afso_CODE + ')'}</td>
                                <td style={{ textAlign: 'left' }}>{item.depot_NAME + '(' + item.depot_ID + ')'}</td>
                                <td style={{ textAlign: 'right' }}>{item.device_ID}</td>
                                <td style={{ textAlign: 'left' }}>{item.ownername}</td>
                                <td style={{ textAlign: 'left' }}>{item.nom_1_NAME}</td>
                                <td style={{ textAlign: 'left' }}>{item.nom_2_NAME}</td>

                            </tr>
                        ))
                    }

                </tbody>
            </table>
            <div align="center" style={{ marginTop: '20px' }}>
                <button type="button" className="button button2" onClick={handleDownload}>Data to Excel</button>
            </div>

            <br />
            <br />
        </>
    }


    if (registerlist == null || registerlist.length == 0) {
        keyregister_comp = <>
        </>
    } else {
        keyregister_comp = <>
            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'Key Register Details for '}
                            <font style={{ color: '#ff8000' }}>{fps_id} </font>
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <td>Sl.No</td>
                        <td>Month</td>
                        <td>Year</td>
                        <td>Total Card</td>
                        <td>Total Units</td>
                        <td>Availed Cards</td>
                    </tr>

                </thead>
                <tbody>
                    {
                        registerlist.map((item, index) => (
                            <tr key={item.dist_NAME_EN}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>{MonthC[item.month - 1]}</td>
                                <td style={{ textAlign: 'right' }}>{item.year}</td>
                                <td style={{ textAlign: 'right' }}>{item.total_cards}</td>
                                <td style={{ textAlign: 'right' }}>{item.total_units}</td>
                                <td style={{ textAlign: 'right' }}>{item.availed_cards}</td>

                            </tr>
                        ))
                    }

                </tbody>
            </table>
            <div align="center" style={{ marginTop: '20px' }}>
                <button type="button" className="button button2" onClick={exportToExcelKeyRegister}>Data to Excel</button>
            </div>
            <br />
            <br />

        </>
    }

    if (allotmentlist == null || allotmentlist.length == 0) {
        allotment_comp = <>
        </>
    } else {
        allotment_comp = <>
            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'Allotment Details for '}
                            <font style={{ color: '#ff8000' }}>{fps_id} </font>
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <td rowSpan={2}>Sl.No</td>
                        <td rowSpan={2} >Month</td>
                        <td rowSpan={2}>Year</td>
                        <td colSpan={allotmentlist[0].lst.length} rowSpan={1}>Allotment <br />(Kgs/Lts/Pkts)</td>
                        <td colSpan={allotmentlist[0].lst.length} rowSpan={1}>Sale <br />(Kgs/Lts/Pkts)</td>
                    </tr>
                    <tr className="tableheader">
                        {
                            allotmentlist[0].lst.map((item, index) => (
                                <th >{item.comm_name_en}</th>
                            ))}
                        {
                            allotmentlist[0].lst.map((item, index) => (
                                <th >{item.comm_name_en}</th>
                            ))}

                    </tr>

                </thead>
                <tbody>
                    {
                        allotmentlist.map((item, index) => (
                            <tr key={item.dist_NAME_EN}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>{MonthC[item.month - 1]}</td>
                                <td style={{ textAlign: 'right' }}>{item.year}</td>
                                {
                                    item.lst.map((item1, index) => (
                                        <td style={{ textAlign: 'right' }}>{item1.allot_qty}</td>
                                    ))}
                                {
                                    item.lst.map((item1, index) => (
                                        <td style={{ textAlign: 'right' }}>{item1.sale_qty}</td>
                                    ))}

                            </tr>
                        ))
                    }

                </tbody>
            </table>
            <div align="center" style={{ marginTop: '20px' }}>
                <button type="button" className="button button2" onClick={exportToExcelAllotment}>Data to Excel</button>
            </div>
            <br />
            <br />


        </>
    }


    if (fpsstockdetails == null || fpsstockdetails.length == 0) {
        fpsstockdetails_comp = <>
        </>
    } else {
        fpsstockdetails_comp = <>

            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{'FPS Stock Details for '}
                            <font style={{ color: '#ff8000' }}>{fps_id} </font>
                            {/* for <font style= {{color:'#bfff00' }}>{MonthC[month-1]}-{year} </font> */}

                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>Commodity</th>
                        <th rowSpan={2}>Alloted Qty</th>
                        <th rowSpan={2}>OB Qty</th>
                        <th colSpan={2}>Received Qty</th>
                        <th rowSpan={2}>Issued Qty</th>
                        <th rowSpan={2}>CB Qty</th>
                    </tr>
                    <tr className="tableheader">
                        <th>Regular</th>
                        <th>Extra</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        fpsstockdetails.map((item, index) => (
                            <tr key={item.comm_name_en}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>{item.comm_name_en}</td>
                                <td style={{ textAlign: 'right' }}>{item.allotted_qty}</td>
                                <td style={{ textAlign: 'right' }}>{item.ob}</td>
                                <td style={{ textAlign: 'right' }}>{item.received_qty}</td>
                                <td style={{ textAlign: 'right' }}>{item.extra_ro}</td>
                                {/* <td style={{ textAlign: 'right' }}>{item.sixi_case}</td>  */}
                                <td style={{ textAlign: 'right' }}>{item.issued_qty}</td>
                                <td style={{ textAlign: 'right' }}>{item.cb}</td>

                            </tr>
                        ))
                    }
                </tbody>
            </table>

            <div align="center" style={{ marginTop: '20px' }}>
                <button type="button" className="button button2" onClick={exportToExcelFpsDetalis}>Data to Excel</button>
            </div>
            <br />
            <br />
        </>
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    return (
        <>
            {fpsStatus_comp}

            {keyregister_comp}

            {allotment_comp}

            {fpsstockdetails_comp}

            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
            <br></br>
            <br></br>

        </>
    );
};

export default FPS_Status_details;